
import ReviewsComment from '~/components/catalog/reviews/Comment/index';

export default {
  name: 'ReviewsCommentWrapper',
  components: {ReviewsComment},
  props: {
    comments: {
      type: Array,
      required: true,
    },
  },
}
